import React from 'react';
import Navbar from './Navbar.js';
import Footer from './footer.js';
import './About.css';
// import doctorImage from './doctor.png';
// import teacherImage from './teacher.jpeg';
// import analystImage from './analyst.png';
// import lawyerImage from './lawyer.png';
import doctor from './doctor.mp4';
import teacher from './teacher.mp4';
import mentor from './mentor.mp4';
import lawyer from './lawyer.mp4';

const About = () => {
  return (
    <div className="abt-patent-page">
      <Navbar />
      <main className="abt-patent-hero">
        <h1>About Cnyda Dynamics Company</h1>
        
        <section className="abt-patent-body">
          <div className="abt-patent-description">
            <p>
             Cnyda dynamics is a research & development company which primarily focuses on advanced mathematics and technology research including Artificial Intelligence, Machine Learning and Big Data Analytics.
              The founder's driving force behind starting the company was a deep-seated passion to address the complex problems that plague our society, and to use technology, mathematics and other sciences as a tool to find creative solutions to these challenges. 
              The current political and economic environment presents a significant challenge for nations to distribute their wealth and opportunities fairly among their citizens. This issue requires careful consideration and innovative solutions to ensure that all members of society have access to the resources they need to live a dignified life. In order to aid the governments across the globe in achieving the above objectives, 
              our company firmly believes that the success of any government or private organization, 
              regardless of the capatalist or communist economic system in that country, hinges on four essential factors:
            </p>
          </div>

          <div className="abt-division-block">
            <h2 className="abt-patent-sub-heading">AI Doctor Division:</h2>
            <div className="abt-patent-description">
              <p>
                We believe that all the citizens should have access to healthcare options that are not only effective but also financially accessible, so that they can prioritize the well-being of themselves and their families without breaking the bank. The healthcare experience for a common citizen should be on par with that of a wealthy citizen, without any disparities in care The reference to wealthy citizens here is to serve as a benchmark/reference point for assessing the quality of healthcare received by common citizens in that country.
              </p>
              <video 
                src={doctor} 
                className="abt-patent-media" 
                autoPlay 
                loop 
                muted 
                playsInline
              />
            </div>
          </div>

          <div className="abt-division-block">
            <h2 className="abt-patent-sub-heading">AI Teacher Division:</h2>
            <div className="abt-patent-description">
              <p>
               Every citizen, regardless of their family's educational heritage, should be granted the chance to learn from and be mentored by individuals with exceptional cognitive abilities or an AI avatar with such brain, thereby cultivating rationality and knowledge from a formative age. The lack of such mentorship is a primary reason for the under-achievement, high crime rate and socio-economic disadvantages experienced by children from lower-income families.
              </p>
               <video 
                src={teacher} 
                className="abt-patent-media" 
                autoPlay 
                loop 
                muted 
                playsInline
              />
            </div>
          </div>

          <div className="abt-division-block">
            <h2 className="abt-patent-sub-heading">AI Mentor Division:</h2>
            <div className="abt-patent-description">
              <p>
                The emphasis on memory-based examinations in the current educational system often results in a disconnect between education and true knowledge acquisition, hindering the learning process and limiting the potential of students. Governments should strive to offer their citizens not just education, but also the acquisition of marketable skills, so that they may earn a decent living and enjoy the dignity of financial independence.
              </p>
               <video 
                src={mentor} 
                className="abt-patent-media" 
                autoPlay 
                loop 
                muted 
                playsInline
              />
            </div>
          </div>

          <div className="abt-division-block">
            <h2 className="abt-patent-sub-heading">AI Lawyer Division:</h2>
            <div className="abt-patent-description">
              <p>
                Any citizen should be able to protect their property and self-respect through legal means, regardless of their socioeconomic status. The legal system should be accessible and affordable for all, ensuring that justice is not limited to those with the means to afford it.
                The company is actively developing innovative Artificial Intelligence systems that closely mimic human thought processes, offering exceptional reliability at a fraction of the cost typically associated with existing AI technologies. This approach makes it possible for common citizens to benefit from these advanced solutions. To accomplish the above objectives, the company aims to collaborate with governments and corporations to facilitate technology-driven policy changes.
              </p>
               <video 
                src={lawyer} 
                className="abt-patent-media" 
                autoPlay 
                loop 
                muted 
                playsInline
              />  
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;